module.exports = __webpack_public_path__ + "kudos_18.svg?459ed8796c26a223ed0c4b477531a573";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_18.svg
// module id = 115
// module chunks = 0